module.exports = __webpack_public_path__ + "img/details-product.7975aa7.webp";